/* eslint-disable sonarjs/no-duplicate-string */

import {
    Channel,
    CommonConfigType,
    commonConfig as commonDefaultConfig,
    Envs,
    Markets,
} from 'scbk-services';

export const CommonConfig: CommonConfigType = {
    ...commonDefaultConfig,
    indexRoute: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '/keylanding/home/KLDHOM000_00MS',
                channel: {
                    [Channel.IB]: '/keylanding/home/KLDHOM000_00MS', //인터넷뱅킹 로그인페이지
                    [Channel.MB]: '/keylanding/home/KLDHOM000_00MS',
                },
            },
        },
    },
    landingRoute: {
        value: '/keylanding/home/KLDHOM000_00MS',
    },
    loginRoute: {
        value: '',
        markets: {
            [Markets.KR]: {
                value: '/login/advance/LGNADV000_00MS',
                channel: {
                    [Channel.IB]: '/login/advance/LGNADV000_00MS', // 프리로그인
                    [Channel.MB]: '/login/advance/LGNADV000_00MS',
                },
            },
        },
    },
    errorRoute: {
        value: '/commons/error/COMCMP004_01MS', // 일반 error page
    },
    error500Route: {
        value: '/commons/error/COMCMP004_03MS', // 500 에러 페이지
    },
    errorSvcTimeRoute: {
        value: '/commons/error/COMUTL009_10MS', // 이용시간 에러 페이지
    },
    errorRestrictCountryRoute: {
        value: '/commons/error/COMUTL010_10MS', // 경제제재국가 접근 금지 안내 에러 페이지
    },
    errorScreenId: {
        value: 'COMCMP004_01MS', // 일반 error page
    },
    error500ScreenId: {
        value: 'COMCMP004_03MS', // 500 에러 페이지
    },

    // 홈페이지 도메인(Resource)
    homePageDomain: {
        value: 'https://www.standardchartered.co.kr',
        env: {
            [Envs.LOCAL]: 'https://wwwut.standardchartered.co.kr',
            [Envs.DEV]: 'https://owwwsit.standardchartered.co.kr',
            [Envs.SIT]: 'https://owwwsit.standardchartered.co.kr',
            [Envs.UAT]: 'https://owwwsit.standardchartered.co.kr',
            [Envs.PROD]: 'https://www.standardchartered.co.kr',
        },
    },

    // 홈페이지 도메인
    HomePageShortDomain: {
        value: 'https://www.sc.co.kr',
        env: {
            [Envs.LOCAL]: 'https://www.sc.co.kr',
            [Envs.DEV]: 'https://www.sc.co.kr',
            [Envs.SIT]: 'https://www.sc.co.kr',
            [Envs.UAT]: 'https://www.sc.co.kr',
            [Envs.PROD]: 'https://www.sc.co.kr',
        },
    },

    // MPMS 도메인(Resource)
    mpmsDomain: {
        value: 'https://m.sc.co.kr',
        env: {
            [Envs.LOCAL]: 'https://ma3ut.standardchartered.co.kr',
            [Envs.DEV]: 'https://ma3ut.standardchartered.co.kr',
            [Envs.SIT]: 'https://ma3ut.standardchartered.co.kr',
            [Envs.UAT]: 'https://ma3uat.standardchartered.co.kr',
            [Envs.PROD]: 'https://m.sc.co.kr',
        },
    },

    // 구인뱅 도메인
    legacyInternetBankingDomain: {
        value: 'https://open.standardchartered.co.kr',
        env: {
            [Envs.LOCAL]: 'https://oibut.standardchartered.co.kr',
            [Envs.DEV]: 'https://oibut.standardchartered.co.kr',
            [Envs.SIT]: 'https://oibsit.standardchartered.co.kr',
            [Envs.UAT]: 'https://oibuat.standardchartered.co.kr',
            [Envs.PROD]: 'https://open.standardchartered.co.kr',
        },
    },

    // MA30 V2 도메인
    ma30Domain: {
        value: 'https://ma3-v2.sc.co.kr',
        env: {
            [Envs.LOCAL]: 'https://ma3ut-v2.sc.co.kr',
            [Envs.DEV]: 'https://ma3ut-v2.sc.co.kr',
            [Envs.SIT]: 'https://ma3sit-v2.sc.co.kr',
            [Envs.UAT]: 'https://ma3uat-v2.sc.co.kr',
            [Envs.PROD]: 'https://ma3-v2.sc.co.kr',
        },
    },
};
